import '../../css/codeContainer.css'

const SingleLine = (props) => (
    <pre className="code__format">{props.children}</pre>
)

export default SingleLine